<template>
    <div>
        <div class="cc-sec-h">Подключённые каналы</div>
        <p v-if="commChannels.length" class="cc-hint">Нажмите на нужный канал, чтобы подключить по нему контроль переписки.</p>
        <div class="cc-ch-list">
            <div v-if="!commChannels.length" class="cc-ch-empty">
                Пока нет подключённых каналов, с доступным контролем переписки. Подключите WhatsApp, Telegram или MAX, чтобы настроить контроль переписки.
            </div>
            <button
                v-for="channel in commChannels"
                :key="channel.id"
                type="button"
                :class="['cc-ch', { on: selectedCommChannelId === channel.id }]"
                @click="$emit('select-channel', channel.id)"
            >
                <span class="casc-ch-ico" :style="{ background: channel.bg }">
                    <v-img
                        v-if="channel.image"
                        transition="slide-x-transition"
                        :src="channel.image"
                        class="casc-ch-ico__img"
                    />
                    <v-icon v-else size="20" color="#fff">{{ channel.mdiIcon }}</v-icon>
                </span>
                <span class="cc-ch-tx">
                    <span class="cc-ch-n">{{ channel.displayName }}</span>
                    <span class="cc-ch-d">{{ channel.controlDescription }}</span>
                </span>
                <span class="cc-ch-arr">
                    <v-icon size="18">
                        {{ selectedCommChannelId === channel.id ? 'mdi-check' : 'mdi-chevron-right' }}
                    </v-icon>
                </span>
            </button>
        </div>
        <div v-if="selectedCommChannel" class="cc-detail">
            <div class="cc-warn">
                <div class="cc-warn-ic">!</div>
                <div class="cc-warn-tx">
                    <b>Важно!</b>Для включения трансляции пройдите
                    <a :href="commHelpUrl" target="_blank" rel="noopener">инструкцию</a>
                </div>
            </div>
            <StarterPackCommControlBlock
                :key="selectedCommChannel.id"
                :connector-id="selectedCommChannel.id"
                :channel-display-name="selectedCommChannel.displayName"
                @phones-updated="$emit('phones-updated', $event)"
            />
        </div>
    </div>
</template>

<script>
import StarterPackCommControlBlock from '../StarterPackCommControlBlock.vue'

export default {
    name: 'StarterPackDrawerComm',
    components: { StarterPackCommControlBlock },
    props: {
        commChannels: {
            type: Array,
            default: () => [],
        },
        selectedCommChannelId: {
            type: [String, null],
            default: null,
        },
        selectedCommChannel: {
            type: Object,
            default: null,
        },
        commHelpUrl: {
            type: String,
            required: true,
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/vars.sass';

.cc-sec-h {
    margin-bottom: 11px;
    color: $dark-new;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 13px;
    font-weight: 800;
}

.cc-hint {
    margin: 0 0 13px;
    color: $muted-new;
    font-size: 12.5px;
    line-height: 1.5;
}

.cc-ch-list {
    display: flex;
    flex-direction: column;
    gap: 9px;
}

.cc-ch-empty {
    padding: 13px;
    color: $muted-light-new;
    font-size: 12.5px;
    line-height: 1.5;
    text-align: center;
    background: #f6f7f9;
    border: 1px dashed $border-new;
    border-radius: 10px;
}

.cc-ch {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 11px 13px;
    text-align: left;
    cursor: pointer;
    background: #fff;
    border: 1px solid $border-new;
    border-radius: 11px;
    transition: 0.15s;

    &:hover {
        border-color: #c2c8d4;
    }
}

.cc-ch.on {
    background: $bcg-card-new;
    border-color: $main-new;
    box-shadow: 0 0 0 3px rgba(82, 90, 213, 0.12);
}

.cc-ch.on .cc-ch-arr {
    color: $main-new;
}

.casc-ch-ico {
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    overflow: hidden;
    border-radius: 8px;
}

.casc-ch-ico ::v-deep .v-icon {
    line-height: 1 !important;
    font-size: 18px !important;
    display: block;
}

.casc-ch-ico__img {
    width: 100%;
    height: 100%;
}

.casc-ch-ico__img ::v-deep .v-image__image {
    background-size: contain !important;
}

.cc-ch-tx {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 0;
    gap: 1px;
}

.cc-ch-n {
    color: $dark-new;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 13.5px;
    font-weight: 700;
}

.cc-ch-d {
    color: $muted-new;
    font-size: 11px;
}

.cc-ch-arr {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    color: $muted-light-new;
    line-height: 1;
}

.cc-ch-arr ::v-deep .v-icon {
    color: inherit !important;
}

.cc-detail {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid $border-new;
}

.cc-warn {
    display: flex;
    align-items: flex-start;
    gap: 9px;
    padding: 12px 14px;
    margin-bottom: 20px;
    background: #fff6e8;
    border: 1px solid #f6d69a;
    border-radius: 11px;
}

.cc-warn-ic {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 17px;
    height: 17px;
    margin-top: 1px;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    background: #e0353b;
    border-radius: 50%;
}

.cc-warn-tx {
    color: #8a6212;
    font-size: 12.5px;
    line-height: 1.5;
}

.cc-warn-tx a {
    color: $main-new;
    font-weight: 600;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}

.cc-warn-tx b {
    display: block;
    margin-bottom: 2px;
    color: #a8431a;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-weight: 800;
}
</style>
